import _ from 'lodash';

export default function selector(storeState, props) {
    const { open, selectedFlexBrandId } = _.get(storeState, `flexSegmentsForm`);
    return {
        open,
        selectedFlexBrandId,
    };
}
